import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/LeafletPopupTheme.css';
// import './styles/theme.css';
// import './styles/modals.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './store/store';


const root = ReactDOM.createRoot(document.getElementById('root'));
// console.log(process.env)
root.render(
    <Provider store={store}>
        <App />
    </Provider>
);